var map = {
	"./blackjack.webp": 6600,
	"./cases.webp": 4613,
	"./crash.webp": 9135,
	"./duels.webp": 7439,
	"./mines.webp": 6516,
	"./placeholder.webp": 7869,
	"./roll.webp": 3575,
	"./towers.webp": 7242,
	"./upgrader.webp": 3418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;